import React, { useEffect, useState } from 'react';
import { Form, Input, DatePicker, Button, Row, Col, message, Select } from 'antd';
import axiosInstance from '../../services/axiosInstance';
import moment from 'moment';
import usePermissions from '../../hooks/usePermissions';

const AcceptRejectOrdSheet = ({ handleClose }) => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const { hasPermission } = usePermissions();

    const hasAllPermission = hasPermission("can_download_all_accept_reject_sheet");
    const hasSpecificPermission = hasPermission("can_download_specific_accept_reject_sheet");
    const hasManagerPermission = hasPermission("can_download_manager_accept_reject_sheet");

    const queryTypeOptions = [
        hasAllPermission && { value: "all", label: "All" },
        hasSpecificPermission && { value: "specific", label: "Specific" },
        hasManagerPermission && { value: "manager", label: "Manager" },
    ].filter(Boolean);

    const [queryType, setQueryType] = useState(
        queryTypeOptions.length === 1 ? queryTypeOptions[0].value : ""
    );

    const handleFinish = async (values) => {
        setLoading(true);
        try {
            const from_date = values.dates[0].format('YYYY-MM-DD');
            const to_date = values.dates[1].format('YYYY-MM-DD');
            let email = values.email || null;
            let managerEmail = values.manager_email || null;

            let finalQueryType = queryType;
            if (!finalQueryType) {
                finalQueryType = values.query_type;
            }

            const params = {
                from_date,
                to_date,
                query_type: finalQueryType,
            };
            if (finalQueryType === "specific") {
                params.email = email;
            }
            if (finalQueryType === "manager") {
                params.manager_email = managerEmail;
            }

            const response = await axiosInstance.get('/task/v2/accept-reject-order-sheet/', {
                params,
                responseType: 'blob'
            });

            if (response.status === 200) {
                const blob = new Blob([response.data], {
                    type: response.headers['content-type'],
                });

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${moment().format('DD-MM-YYYY hh:mm A')}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                message.success("Sheet Download Successfully");
                handleClose();
            } else {
                message.error("Something went wrong");
            }
        } catch (err) {
            if (
                err?.response?.data instanceof Blob &&
                err?.response?.headers['content-type']?.includes('application/json')
            ) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorJson = JSON.parse(reader.result);
                        const errorMsg = errorJson?.message || errorJson?.detail || 'Error downloading sheet';
                        message.error(errorMsg);
                    } catch (parseErr) {
                        message.error("Unknown error");
                    }
                };
                reader.readAsText(err.response.data);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form form={form} layout="vertical" onFinish={handleFinish}>
            <Row style={{ width: "100%" }}>
                <Col span={24}>
                    <Form.Item
                        label="Select Date Range"
                        name="dates"
                        rules={[{ required: true, message: 'Please select date range' }]}
                    >
                        <DatePicker.RangePicker style={{ width: "100%" }} />
                    </Form.Item>
                </Col>
            </Row>

            {queryTypeOptions.length > 1 && (
                <Row style={{ width: "100%" }}>
                    <Col span={24}>
                        <Form.Item
                            label="Query Type"
                            name="query_type"
                            rules={[{ required: true, message: 'Please select a query type' }]}
                        >
                            <Select
                                style={{ width: '100%' }}
                                placeholder="Select Query Type"
                                value={queryType}
                                onChange={(value) => setQueryType(value)}
                            >
                                {queryTypeOptions.map((option) => (
                                    <Select.Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            )}

            {queryType === 'specific' && (
                <Row style={{ width: "100%" }}>
                    <Col span={24}>
                        <Form.Item
                            label="Enter Email"
                            name="email"
                            rules={[{ required: true, message: 'Please enter email' }]}
                        >
                            <Input placeholder="Enter Email" />
                        </Form.Item>
                    </Col>
                </Row>
            )}

            {queryType === 'manager' && (
                <Row style={{ width: "100%" }}>
                    <Col span={24}>
                        <Form.Item
                            label="Enter Manager Email"
                            name="manager_email"
                            rules={[{ required: true, message: 'Please enter manager email' }]}
                        >
                            <Input placeholder="Enter Manager Email" />
                        </Form.Item>
                    </Col>
                </Row>
            )}

            <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                    Submit
                </Button>
            </div>
        </Form>
    );
};

export default AcceptRejectOrdSheet;
